import { useToast } from '#app/components/Toasts/hooks/useToast.js';
import { type Message } from '#app/components/Toasts/types.js';
import { useLocation } from '#app/hooks/useLocation.js';
import { copyToClipboard } from '#app/utilities/copyToClipboard.js';
import { useCallback } from 'react';

type useCopyToClipboard = () => (
  textToCopy: string,
  options?: useCopyToClipboardOptions,
) => Promise<void>;

type useCopyToClipboardOptions = {
  errorToast?: Message;
  hideToast?: boolean;
  successToast?: Message;
};

export const useCopyToClipboard: useCopyToClipboard = () => {
  const toast = useToast();
  const location = useLocation();
  const copyUrl = useCallback(
    async (
      textToCopy: string,
      {
        errorToast = 'Failed to copy the link. Please try again.',
        hideToast = false,
        successToast = 'Successfully copied link.',
      }: useCopyToClipboardOptions = {},
    ) => {
      try {
        await copyToClipboard(textToCopy ?? location.currentURL);
        if (hideToast) return;
        toast.success(successToast);
      } catch {
        toast.error(errorToast);
      }
    },
    [toast, location.currentURL],
  );

  return copyUrl;
};
